export default __webpack_public_path__ + "static/media/robotnicza.3433f1af.jpg";